import coreStore from "./core-store";

const remoteResource = 'processing/api/v1/mappings';

const store = coreStore.createCoreStore('importMapping', remoteResource);

export default store;
